import React, { useContext, useEffect } from "react"

import PropTypes from "prop-types"
import { Link, navigate } from "gatsby"
import { Row, Col, Image, Container } from "react-bootstrap"

import Ham from "../../images/icons/wdn-ham.svg"

import { GlobalAuthContext } from "../../context/authContext"

import {
  FETCH_OPTIONS,
  FETCH_PRIMARY_MENUS,
  FETCH_SECONDARY_MENUS,
} from "../shared-actions/globalOptions"

import "./header.scss"
import { LOGO } from "../../constants/footer"
import ModalComponent from "../modal/modal"
import ConfirmModal from "../confirm-dialog-global"
import PrimaryMenu from "./primary-menu"

const Header = ({ siteTitle, isMenuOpen, handleHamClick, hide, active }) => {
  const { state, dispatch } = useContext(GlobalAuthContext)

  const Logo = state?.global_options?.logo?.url || LOGO

  const handleModalHide = () => {
    dispatch({
      type: "MODAL",
      payload: {
        showModal: 0,
      },
    })
  }

  const handleLogoutClick = async () => {
    await dispatch({
      type: "LOGOUT",
    })
    navigate("/")
  }

  const handleEscKey = () => {
    document.addEventListener(
      "keydown",
      e => {
        if (e?.key === "Escape") {
          handleHamClick(0)
        }
      },
      false
    )
  }

  useEffect(() => {
    FETCH_OPTIONS(dispatch)
    FETCH_PRIMARY_MENUS(dispatch)
    FETCH_SECONDARY_MENUS(dispatch)
    handleEscKey(isMenuOpen)
    try {
      const user = localStorage.user
      if (!user) {
        dispatch({
          type: "LOGOUT",
        })
      }
      if (!localStorage.token) {
        dispatch({
          type: "LOGOUT",
        })
      }
    } catch (err) {
      dispatch({
        type: "LOGOUT",
      })
    }
  }, [state.isAuthenticated, state.isEmailVerified]) // eslint-disable-line react-hooks/exhaustive-deps

  // console.log(state.user.candidate)

  let baseUrl = ""

  if (state?.user?.candidate?.id) {
    baseUrl = "/candidate/profile/dashboard"
  } else if (state?.user?.company?.id) {
    baseUrl = "/company/profile/dashboard"
  } else {
    baseUrl = "/"
  }

  return (
    <header className="header-menu position-relative ">
      {isMenuOpen && (
        <a href="#" onClick={handleHamClick} className="backdrop"></a>
      )}
      <Container>
        <ModalComponent
          show={state.modal.showModal !== 0}
          setShow={handleModalHide}
        >
          {state.modal.showModal === 1 && (
            <ConfirmModal
              id={state?.modal?.deleteId}
              setShow={handleModalHide}
              onOkClick={state?.modal?.deleteItem}
            />
          )}
        </ModalComponent>
        <Row className="align-items-center">
          <Col lg="2" xs="6">
            <Link to={baseUrl}>
              <Image
                src={Logo}
                className="logo"
                alt={state?.global_options?.logo?.alt}
              />
            </Link>
          </Col>
          <Col lg="10" xs="6">
            <PrimaryMenu
              state={state}
              handleLogoutClick={handleLogoutClick}
              isMenuOpen={isMenuOpen}
              hide={hide}
              active={active}
              Ham={Ham}
              handleHamClick={handleHamClick}
            />
          </Col>
        </Row>
      </Container>
    </header>
  )
}

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
